<template>
  <v-row no-gutters style="height: 100%">
    <v-col cols="12">
      <v-row no-gutters>
        <v-col cols="12" class="mt-4">
          <span class="text-subtitle-2 font-weight-normal">
            {{ $t('message.pages.drm.styleTab') }}
          </span>
        </v-col>
        <v-col cols="12" class="mt-6">
          <v-row no-gutters>
            <v-col cols="6" class="pr-4">
              <v-select-legacy
                v-model="group.fontFamily"
                :items="fontFamilyItems"
                item-text="text"
                item-value="value"
                :label="$t('message.pages.drm.settingsForm.mainFont')"
                outlined
                color="primary"
              ></v-select-legacy>
            </v-col>
            <v-col cols="6" class="pl-4">
              <v-select-legacy
                v-model="group.fontSize"
                :items="fontSizeItems"
                :label="$t('message.pages.drm.settingsForm.mainFont')"
                outlined
                color="primary"
              ></v-select-legacy>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6" class="pr-4">
          <v-row no-gutters align="center">
            <v-col cols="5">
              <span>{{
                $t('message.pages.drm.settingsForm.backgroundColor')
              }}</span>
            </v-col>
            <v-col cols="7">
              <v-menu
                offset-x
                v-model="menuBoxColor"
                top
                nudge-bottom="105"
                nudge-left="16"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ml-2"
                    :color="group.boxColor"
                    v-on="on"
                    :style="setMenuBoxColor"
                    icon
                    elevation="3"
                  ></v-btn>
                </template>
                <v-color-picker
                  elevation="3"
                  v-model="group.boxColor"
                  flat
                  mode="hexa"
                  hide-mode-switch
                  :maxlength="7"
                ></v-color-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6" class="pl-4">
          <v-row no-gutters align="center">
            <v-col cols="5">
              <span>{{ $t('message.pages.drm.settingsForm.textColor') }}</span>
            </v-col>
            <v-col cols="7">
              <v-menu
                offset-x
                v-model="menuFontColor"
                top
                nudge-bottom="105"
                nudge-left="16"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ml-2"
                    :color="group.fontColor"
                    v-on="on"
                    :style="setMenuFontColor"
                    icon
                    elevation="3"
                  ></v-btn>
                </template>
                <v-color-picker
                  elevation="3"
                  v-model="group.fontColor"
                  flat
                  mode="hexa"
                  hide-mode-switch
                  :maxlength="7"
                ></v-color-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-8 d-flex align-center justify-center">
          <v-card
            width="460"
            height="258.75"
            class="d-flex align-start justify-start"
            flat
          >
            <v-img
              style="width: 460px; height: 258.75px; position: absolute"
              src="@/assets/pandaBackgroundPhoto.png"
            >
            </v-img>
            <v-card
              class="ml-2 px-2 py-1 mt-2 d-flex flex-column"
              :color="group.boxColor"
            >
              <span
                :style="{
                  color: group.fontColor,
                  fontSize: group.fontSize + 'px',
                  fontFamily: group.fontFamily + ' !important',
                }"
              >
                {{ boxLines.text1 }}
              </span>
              <span
                :style="{
                  color: group.fontColor,
                  fontSize: group.fontSize + 'px',
                  fontFamily: group.fontFamily + ' !important',
                }"
              >
                {{ boxLines.text2 }}
              </span>
              <span
                :style="{
                  color: group.fontColor,
                  fontSize: group.fontSize + 'px',
                  fontFamily: group.fontFamily + ' !important',
                }"
              >
                {{ boxLines.text3 }}
              </span>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="d-flex justify-end align-end pb-6">
      <v-card width="100%" flat>
        <v-card-actions>
          <v-spacer />
          <v-btn
            min-width="140px"
            text
            class="mr-2"
            :disabled="isFetching"
            @click="handleClose"
          >
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            min-width="140px"
            color="primary"
            :disabled="isFetching || !hasEditDrmPerm"
            :loading="isFetching"
            @click="handleConfirm"
          >
            <span class="mx-2"> {{ $t('message.actions.save') }} </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import drmApi from '@/services/drmApi'
import { mapMutations } from 'vuex'
import _ from 'lodash'

export default {
  name: 'DrmSettingsStyle',
  components: {},
  props: {
    drmGroup: Object,
    handleCloseModal: Function,
    chieldFunction: Array,
    chieldCleanFunction: Array,
  },
  data: () => ({
    isFetching: false,
    groupId: '',
    group: {
      fontFamily: 'arial',
      fontColor: '#FFFFFF',
      fontSize: 12,
      boxColor: '#7999CE',
      boxOpacity: 1,
    },
    boxLines: {
      text1: 'Licenciado para',
      text2: 'Panda Video',
      text3: 'CPF 123.456.789-00',
    },
    fontFamilyItems: [
      { text: 'Arial', value: 'arial' },
      { text: 'Fredoka Regular', value: 'fredoka-regular' },
      { text: 'Helvetica', value: 'helvetica' },
      { text: 'Times New Roman', value: 'times-new-roman' },
    ],
    fontSizeItems: [12, 14, 16, 18, 20, 22],
    menuFontColor: false,
    menuBoxColor: false,
    initialObject: {},
  }),
  computed: {
    hasEditDrmPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-watermark') ??
        false
      )
    },
    setMenuFontColor() {
      return {
        backgroundColor: this.group.fontColor,
        borderRadius: '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    setMenuBoxColor() {
      return {
        backgroundColor: this.group.boxColor,
        borderRadius: '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
  },
  watch: {
    drmGroup: {
      immediate: true,
      handler(val) {
        this.groupId = val.id
        this.group.fontFamily = val.config['font-family'] || 'fredoka-regular'
        this.group.fontColor = val.config['font-color'] || '#FFFFFFFF'
        this.group.fontSize = Number(val.config['font-size']) || 18
        this.group.boxColor = val.config['box-color'] || '#7999CEFF'
        this.group.boxOpacity = val.config['box-opacity'] || 1
        if (this.group.fontColor.length < 8) {
          this.group.fontColor += 'FF'
        }
        if (this.group.boxColor.length < 8) {
          this.group.boxColor += 'FF'
        }
        this.initialObject = {
          percent_ts: this.group.percentTs,
          'font-family': this.group.fontFamily.toString(),
          'font-color': this.group.fontColor.toString(),
          'font-size': this.group.fontSize.toString(),
          'box-color': this.group.boxColor.toString(),
        }
        this.chieldFunction.push(this.checkChange)
        this.chieldCleanFunction.push(this.resetData)
      },
    },
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_SHOULD_FETCH_ALL_VIDEOS',
    ]),
    getOpacityFromHexColor(hexColor) {
      const color = hexColor.startsWith('#') ? hexColor.slice(1) : hexColor
      const colorRegex = /^([0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/
      if (!colorRegex.test(color)) {
        return 1.0
      }
      const opacityHex = color.slice(-2)
      const opacityDecimal = parseInt(opacityHex, 16) / 255
      const opacity = Math.round(opacityDecimal * 100) / 100
      return opacity
    },
    handleConfirm() {
      let boxOpacityVal = this.getOpacityFromHexColor(
        this.group.boxColor.toString()
      )
      let groupObject = {
        percent_ts: this.group.percentTs,
        'font-family': this.group.fontFamily.toString(),
        'font-color': this.group.fontColor.toString(),
        'font-size': this.group.fontSize.toString(),
        'box-color': this.group.boxColor.toString(),
        'box-opacity': boxOpacityVal.toString(),
      }
      this.handleEdit(groupObject)
    },
    async handleEdit(groupObject) {
      this.isFetching = true
      try {
        let ret = await drmApi.drmUpdateVideos(this.groupId, groupObject)
        this.isFetching = false
        this.$root.$emit('updateDrmGroup', ret.data)
        this.UPDATE_SHOULD_FETCH_ALL_VIDEOS(true)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: 'Configurações salvas com sucesso!',
        })
        this.handleCloseModal()
      } catch (e) {
        this.isFetching = false
        console.log('e', e)
      }
    },
    async handleClose() {
      if (this.checkChange()) {
        this.$root.$emit(
          'unsavedChangesModal',
          false,
          false,
          false,
          false,
          true
        )
      } else {
        this.handleCloseModal()
      }
    },
    checkChange() {
      return !(
        _.isEqual(
          this.group.fontFamily.toString(),
          this.initialObject['font-family']
        ) &&
        _.isEqual(
          this.group.fontColor.toString(),
          this.initialObject['font-color']
        ) &&
        _.isEqual(
          this.group.fontSize.toString(),
          this.initialObject['font-size']
        ) &&
        _.isEqual(
          this.group.boxColor.toString(),
          this.initialObject['box-color']
        ) &&
        _.isEqual(this.group.percentTs, this.initialObject['percent_ts'])
      )
    },
    resetData() {
      this.group.fontFamily = this.initialObject['font-family']
      this.group.fontColor = this.initialObject['font-color']
      this.group.fontSize = this.initialObject['font-size']
      this.group.boxColor = this.initialObject['box-color']
    },
  },
}
</script>

<style>
.drmBgImg {
  background-image: url('../../../assets/pandaBackgroundPhoto.png');
  background-size: contain;
}
</style>
